import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import type { CalendarFilterType } from "../../hooks/useCalendarFilter";
import type { ChatMessage } from "../Chat/chat";
import { formatHistoryDate } from "../../utils/dateUtils";

export function groupHistoryByDate(
  items: ChatMessage[],
): Record<string, ChatMessage[]> {
  const groups: Record<string, ChatMessage[]> = {};
  for (const item of items) {
    const key = formatHistoryDate(item.timestamp ?? "");
    if (!groups[key]) groups[key] = [];
    groups[key].push(item);
  }
  return groups;
}

export function filterHistoryItemsByCalendar(
  items: ChatMessage[],
  opts: {
    query: string;
    appliedDates?: Dayjs | [Dayjs, Dayjs] | null;
    appliedValue?: CalendarFilterType;
  },
): ChatMessage[] {
  let result = items;

  if (opts.query.trim()) {
    const lowerQuery = opts.query.toLowerCase();
    result = result.filter(
      (item) =>
        item.input?.toLowerCase().includes(lowerQuery) ||
        item.output?.toLowerCase().includes(lowerQuery),
    );
  }

  if (opts.appliedDates && opts.appliedValue) {
    result = result.filter((item) => {
      if (!item.timestamp) return false;
      const itemDate = dayjs(item.timestamp);
      const dates = opts.appliedDates;
      if (Array.isArray(dates)) {
        return (
          itemDate.isAfter(dates[0].subtract(1, "day")) &&
          itemDate.isBefore(dates[1].add(1, "day"))
        );
      }
      const singleDate = dates;
      if (opts.appliedValue === "on") return itemDate.isSame(singleDate, "day");
      if (opts.appliedValue === "before")
        return itemDate.isBefore(singleDate, "day");
      if (opts.appliedValue === "after")
        return itemDate.isAfter(singleDate, "day");
      return true;
    });
  }

  return result;
}
